import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const resourcesAnalysisTable: IHashmapItemComponentProps = {
    NoPermissionMessage,
};
